import carGroupListView from "./page/car/CarGroupListView.vue";
import loginView from "./page/login/LoginView.vue";

const carCreateView = () => import("./page/car/CarCreateView.vue");
const carListView = () => import("./page/car/CarListView.vue");
const seatMapCreateView = () => import("./page/car/SeatMapCreateView");
const seatMapListView = () => import("./page/car/SeatMapListView");
const itemCreateView = () => import("./page/item/ItemCreateView");
const itemListView = () => import("./page/item/ItemListView");
const itemGroupListView = () => import("./page/item/ItemGroupListView");
const itemGroupCreateView = () => import("./page/item/ItemGroupCreateView");
const itemTypeCreateView = () => import("./page/item/ItemTypeCreateView.vue");
const itemTypeListView = () => import("./page/item/ItemTypeListView.vue");
const itemGroupTypeCreateView = () => import("./page/item/ItemGroupTypeCreateView.vue");
const itemGroupTypeListView = () => import("./page/item/ItemGroupTypeListView.vue");
const itemPropertyCreateView = () => import("./page/item/ItemPropertyCreateView.vue");
const itemPropertyListView = () => import("./page/item/ItemPropertyListView.vue");
const orerCreateView = () => import("./page/orer/OrerCreateView");
const orerListView = () => import("./page/orer/OrerListView");
const stationCreateView = () => import("./page/station/StationCreateView");
const physicalPropertyListView = () => import("./page/station/PhysicalPropertyListView");
const stationListView = () => import("./page/station/StationListView");
const lineListView = () => import("./page/line/LineListView");
const lineCreateView = () => import("./page/line/LineCreateView");
const lineCreateViewV2 = () => import("./page/line/LineCreateViewV2");
const login = () => import("./page/login/LoginView");
const passwordReset = () => import("./page/login/PasswordReset.vue");
const dashboardView = () => import("./page/dashboard/DashboardView");
const parkourBasedPriceListView = () => import("./page/parkour/ParkourBasedPriceListView");
const page404 = () => import("./page/Page404");
const page401 = () => import("./page/Page401");
const page500 = () => import("./page/Page500");
const pageMaintenance = () => import("./page/PageMaintenance.vue");
const hardwareListView = () => import("./page/station/HardwareListView");
const stationStatusListView = () => import("./page/station/StationStatusListView");
const stationTypeListView = () => import("./page/station/StationTypeListView");
const equivalentStationListView = () => import("./page/station/EquivalentStationListView");
const trainWhereStationListView = () => import("./page/station/TrainWhereStationListView");
const salesTransactionsListView = () => import("./page/sales-transactions/SalesTransactionsListView.vue");
const unitTree = () => import("./page/unit-tree/UnitTree");
const mainUnitListView = () => import("./page/main-unit/MainUnitListView");
const mainUnitCreateView = () => import("./page/main-unit/MainUnitCreateView");
const salesTransactionsSeatmap = () => import("./page/sales-transactions/SalesTransactionsSeatmap");
const salesTransactionPayment = () => import("./page/sales-transactions/SalesTransactionPayment");
const salesTransactionsTicketResult = () => import("./page/sales-transactions/SalesTransactionsTicketResult");
const salesTransactionsTicketRezervation = () => import("./page/sales-transactions/SalesTransactionsTicketRezervation");
const ticketClassRulesCreateView = () => import("./page/ticket-class-rules/TicketClassRulesCreateView.vue");
const ticketClassRulesListView = () => import("./page/ticket-class-rules/TicketClassRulesListView");
const pageClassListView = () => import("./page/class/ClassListView.vue");
const pageClassCreateView = () => import("./page/class/ClassCreateView.vue");
const priceFamilyListView = () => import("./page/price-family/PriceFamilyListView");
const kilometricBasedPricingView = () => import("./page/pricing/KilometricBasedPricingView");
const trainCreateView = () => import("./page/train/TrainCreateView");
const trainListView = () => import("./page/train/TrainListView");
const passengerTypeListView = () => import("./page/passenger-type/PassengerTypeListView.vue");
const passengerTypeCreateView = () => import("./page/passenger-type/PassengerTypeCreateView.vue");
const userCreateView = () => import("./page/user/UserCreateView");
const userListView = () => import("./page/user/UserListView.vue");
const userAccountDataListView = () => import("./page/user/UserAccountDataListView.vue");
const authorizationManagementView = () => import("./page/authorization-management/AuthorizationManagementView");
const specialServiceCreateView = () => import("./page/special-service/SpecialServiceCreateView.vue");
const specialServiceListView = () => import("./page/special-service/SpecialServiceListView.vue");
const homeView = () => import("./page/home/HomeView.vue");
const additionalServiceListView = () => import("./page/additional-service/AdditionalServiceListView.vue");
const additionalServiceCreateView = () => import("./page/additional-service/AdditionalServiceCreateView.vue");
const additionalServiceTypeListView = () => import("./page/additional-service/AdditionalServiceTypeListView.vue");
const commissionTableCreateView = () => import("./page/commission-table/CommissionTableCreateView.vue");
const commissionTableListView = () => import("./page/commission-table/CommissionTableListView.vue");
const additionalServiceKilometricBasedPricingView = () => import("./page/pricing/AdditionalServiceKilometricBasedPricingView");
const ssrKilometricBasedPricingView = () => import("./page/pricing/SSRKilometricBasedPricingView");
const additionalServiceParkourBasedPricingView = () => import("./page/pricing/AdditionalServiceParkourBasedPricingView.vue");
const ssrParkourBasedPricingView = () => import("./page/pricing/SSRParkourBasedPricingView.vue");
const resourceGroupListView = () => import("./page/resource-group/ResourceGroupListView.vue");
const resourceGroupCreateView = () => import("./page/resource-group/ResourceGroupCreateView.vue");
const trainSetCreateView = () => import("./page/train/TrainSetCreateView.vue");
const trainSetListView = () => import("./page/train/TrainSetListView.vue");
const trainConnectingCreateView = () => import("./page/train/TrainConnectingCreateView.vue");
const trainConnectingListView = () => import("./page/train/TrainConnectingListView.vue");
const sefer = () => import("./page/sefer/Sefer.vue");
const announcementCreateView = () => import("./page/announcement/AnnouncementCreateView.vue");
const announcementListView = () => import("./page/announcement/AnnouncementListView.vue");
const messageTranslationCreateView = () => import("./page/message-translation/MessageTranslationCreateView.vue");
const messageTranslationListView = () => import("./page/message-translation/MessageTranslationListView.vue");
const agentListView = () => import("./page/agent/AgentListView.vue");
const agentCreateView = () => import("./page/agent/AgentCreateView.vue");
const agentPaymentAccountClosingView = () => import("./page/agent/AgentPaymentAccountClosingView.vue");
const agentMultipleCloseAccountPeriod = () => import("./page/agent/AgentMultipleCloseAccountPeriod.vue");
const agentAccountingPeriodTransactions = () => import("./page/agent/AgentAccountingPeriodTransactions.vue");
const agencySalesReportsView = () => import("./page/agent/AgencySalesReportsView.vue");
const agencyEndOfPeriodReportingProceduresView = () => import("./page/agent/AgencyEndOfPeriodReportingProceduresView.vue");
const agentAccountingPeriodTransactionsV2 = () => import("./page/agent/AgentAccountingPeriodTransactionsV2.vue");
const agencySalesReportsViewV2 = () => import("./page/agent/AgencySalesReportsViewV2.vue");
const agencyEndOfPeriodReportingProceduresViewV2 = () => import("./page/agent/AgencyEndOfPeriodReportingProceduresViewV2.vue");
const supervisorApprovalTableView = () => import("./page/box-office/account-status/SupervisorApprovalTableView.vue");
const personnelAccountClosingView = () => import("./page/box-office/account-status/PersonnelAccountClosingView.vue");
const accountClosureConfirmationView = () => import("./page/box-office/account-status/AccountClosureConfirmationView.vue");
const KKYAccountTransferView = () => import("./page/box-office/KKYAccountTransferView.vue");
const boxOfficeListView = () => import("./page/box-office/BoxOfficeListView.vue");
const boxOfficeCreateView = () => import("./page/box-office/BoxOfficeCreateView.vue");
const customerCreateView = () => import("./page/customer-management/CustomerCreateView.vue");
const customerListView = () => import("./page/customer-management/CustomerListView.vue");
const customerPurchaseHistoryView = () => import("./page/customer-management/CustomerPurchaseHistoryView.vue");
const customerConnectedDevicesView = () => import("./page/customer-management/CustomerConnectedDevicesView.vue");
const parkourBasedPricingView = () => import("./page/pricing/ParkourBasedPricingView.vue");
const parkourBasedDynamicPricingView = () => import("./page/pricing/ParkourBasedDynamicPricingView.vue");
const kilometricBasedDynamicPricingView = () => import("./page/pricing/KilometricBasedDynamicPricingView.vue");
const kontenjanCreateView = () => import("./page/kontenjan/KontenjanCreateView.vue");
const kontenjanListView = () => import("./page/kontenjan/KontenjanListView.vue");
const seatMapConnectingTemplateListView = () => import("./page/car/SeatMapConnectingTemplateListView.vue");
const seatMapConnectingTemplateCreateView = () => import("./page/car/SeatMapConnectingTemplateCreateView.vue");
const trainKontenjanAssignmentView = () => import("./page/kontenjan/TrainKontenjanAssignmentView.vue");
const SeferKontenjanAssignmentView = () => import("./page/kontenjan/SeferKontenjanAssignmentView.vue");
const SaleChannelListView = () => import("./page/sale-channel/SaleChannelListView.vue");
const subscriptionPackageListView = () => import("./page/subscription-package/SubscriptionPackageListView.vue");
const subscriptionPackageCreateView = () => import("./page/subscription-package/SubscriptionPackageCreateView.vue");
const packageSaleView = () => import("./page/package-sale/PackageSaleView.vue");
const discountPackageListView = () => import("./page/discount-package/DiscountPackageListView.vue");
const discountPackageCreateView = () => import("./page/discount-package/DiscountPackageCreateView.vue");
const specialServiceRequestCategoryListView = () => import("./page/special-service/SpecialServiceRequestCategoryListView.vue");
const parameterCreateView = () => import("./page/parameter/ParameterCreateView.vue");
const parameterListView = () => import("./page/parameter/ParameterListView.vue");
const titleListView = () => import("./page/customer-management/TitleListView.vue");
const ticketTransactions = () => import("./page/passenger-transactions/TicketTransactions.vue");
const HtmlTicketTransactions = () => import("./page/passenger-transactions/HtmlTicketTransactions.vue");
const firstReport = () => import("./page/reports/FirstReport.vue");
const monthlySalesRejectionReport = () => import("./page/reports/MonthlySalesRejectionReport.vue");
const notificationListView = () => import("./page/notification/NotificationListView.vue");
const notificationCreateView = () => import("./page/notification/NotificationCreateView.vue");
const informationListView = () => import("./page/notification/InformationListView.vue");
const informationCreateView = () => import("./page/notification/InformationCreateView.vue");
const occupancyNotificationListView = () => import("./page/notification/OccupancyNotificationListView.vue");
const memberBlacklistView = () => import("./page/member-blacklist/MemberBlacklistView.vue");
const blackListRuleView = () => import("./page/member-blacklist/BlackListRuleView.vue");
const blackListRuleCreateView = () => import("./page/member-blacklist/BlackListRuleCreateView.vue");
const militaryUnitsListView = () => import("././page/military-transactions/MilitaryUnitsListView");
const muhtiraTransactionsView = () => import("././page/military-transactions/MuhtiraTransactionsView.vue");
const muhtiraDownloadListView = () => import("./page/military-transactions/MuhtiraDownloadListView.vue");
const corporateBasedTransactionsView = () => import("./page/corporate-based-transactions/CorporateBasedTransactionsView.vue");
const trainRegionList = () => import("./page/train/TrainRegionList.vue");
const trainSetMappingListView = () => import("./page/car/TrainSetMappingListView.vue");
const trainSetMappingCreateView = () => import("./page/car/TrainSetMappingCreateView.vue");
// const appVersionListView = () => import("./page/app-version/AppVersionListView.vue");
const connectedTrainDiscountListView = () => import("./page/train/ConnectedTrainDiscountListView.vue");
const connectedTrainDiscountCreateView = () => import("./page/train/ConnectedTrainDiscountCreateView.vue");
const bulkTicketing = () => import("./page/sales-transactions/BulkTicketing.vue");
const internationalTicketTransactions = () => import("./page/international-ticket/InternationalTicketTransactions.vue");
const internationalTicketCardDetails = () => import("./page/international-ticket/InternationalTicketCardDetails.vue");
const internationalTicketPassengerInformation = () => import("./page/international-ticket/InternationalTicketPassengerInformation.vue");
const internationalTicketPayment = () => import("./page/international-ticket/InternationalTicketPayment.vue");
const internationalTicketResult = () => import("./page/international-ticket/InternationalTicketResult.vue");
const InternationalTicketRefund = () => import("./page/international-ticket/InternationalTicketRefund.vue");
const evaluationsListView = () => import("./page/evaluation/EvaluationsListView.vue");
const sendTrainPassengersSms = () => import("./page/send-train-passengers-sms/SendTrainPassengersSms.vue");
const outgoingReceiptsCreateView = () => import("./page/receipt/OutgoingReceiptsCreateView.vue");
const helpMainHeaderListView = () => import("./page/help/HelpMainHeaderListView.vue");
const helpMainHeaderCreateView = () => import("./page/help/HelpMainHeaderCreateView.vue");
const historyView = () => import("./page/intent-history/IntentHistoryView.vue");
const lostPropertyStaffOperationsView = () => import("./page/lost-property/StaffOperationsView.vue");
const lostPropertyAdminOperationsView = () => import("./page/lost-property/AdminOperationsView.vue");
const lostPropertySettingsView = () => import("./page/lost-property/SettingsView.vue");

export const router = [
  // requiresAuth = kullanıcı login olmuş ise
  //{ path: "/", name: "login", component: login, meta: { hideHeader: true , hideQuickMenuSidebar:true },
  //  beforeEnter: (to, from, next) => {
  //    // vuex yok ise boş obje setliyor
  //    const vuexData = JSON.parse(localStorage.getItem('vuex')) || {};
  //    if (vuexData.user && vuexData.user.loggedIn) {
  //      if(from.name === "passwordReset"){
  //        next();
  //      }
  //      // else if (vuexData.user.user.accessToken) {
  //      //   next("/satis-islemleri");
  //      // }
  //      else{
  //        next();
  //      }
  //    }else{
  //      next();
  //    }
  //  },
  //},
  { path: "/", name: "homeView", component: homeView, meta: { hideHeaderAndFooter: false } },
  { path: "*", redirect: "/404" },
  { path: "/giris-yap", name: "loginView", component: loginView, meta: { hideHeaderAndFooter: true } },
  { path: "/sifre-sifirla", name: "passwordReset", component: passwordReset, meta: { hideHeaderAndFooter: true } },
  { path: "/dashboard", name: "dashboardView", component: dashboardView },
  {
    path: "/istasyon-yonetimi",
    name: "stationListView",
    component: stationListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/istasyon-yonetimi-sub-menu/istasyon-yonetimi/show-page" },
  },
  { path: "/istasyon-tanimlama", name: "stationCreateView", component: stationCreateView },
  {
    path: "/istasyon-fiziksel-ozellik-yonetimi",
    name: "physicalPropertyListView",
    component: physicalPropertyListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/istasyon-yonetimi-sub-menu/istasyon-fiziksel-ozellik-yonetimi/show-page" },
  },
  { path: "/hat-yonetimi", name: "lineListView", component: lineListView, meta: { permissionTag: "b2b/yonetici-islemleri-menu/hat-yonetimi/show-page" } },
  // { path: "/hat-tanimlama-old", name: "lineCreateView", component: lineCreateView, meta :{ permissionTag:"b2b/yonetici-islemleri-menu/hat-yonetimi/show-page" } },
  { path: "/hat-tanimlama", name: "lineCreateViewV2", component: lineCreateViewV2 },
  {
    path: "/zaman-cizelgesi-yonetimi",
    name: "orerListView",
    component: orerListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/zaman-cizelgesi-yonetimi/show-page" },
  },
  { path: "/zaman-cizelgesi-tanimlama", name: "orerCreateView", component: orerCreateView },
  {
    path: "/nesne-yonetimi",
    name: "itemListView",
    component: itemListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/nesne-vagon-sub-menu/nesne-yonetimi/show-page" },
  },
  { path: "/nesne-tanimlama", name: "itemCreateView", component: itemCreateView },
  {
    path: "/nesne-grup-sablonu",
    name: "itemGroupListView",
    component: itemGroupListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/nesne-vagon-sub-menu/nesne-grup-sablonu/show-page" },
  },
  { path: "/nesne-grup-tanimlama", name: "itemGroupCreateView", component: itemGroupCreateView },
  { path: "/nesne-tipi-tanimlama", name: "itemTypeCreateView", component: itemTypeCreateView },
  {
    path: "/nesne-tipi-yonetimi",
    name: "itemTypeListView",
    component: itemTypeListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/nesne-vagon-sub-menu/nesne-tipi-yonetimi/show-page" },
  },
  { path: "/nesne-grup-tipi-tanimlama", name: "itemGroupTypeCreateView", component: itemGroupTypeCreateView },
  {
    path: "/nesne-grup-tipi-yonetimi",
    name: "itemGroupTypeListView",
    component: itemGroupTypeListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/nesne-vagon-sub-menu/nesne-grup-tipi-yonetimi/show-page" },
  },
  { path: "/nesne-ozellik-tanimlama", name: "itemPropertyCreateView", component: itemPropertyCreateView },
  {
    path: "/nesne-ozellik-yonetimi",
    name: "itemPropertyListView",
    component: itemPropertyListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/nesne-vagon-sub-menu/nesne-ozellik-yonetimi/show-page" },
  },
  {
    path: "/vagon-tipi-yonetimi",
    name: "carListView",
    component: carListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/nesne-vagon-sub-menu/vagon-tipi-tanimlama/show-page" },
  },
  { path: "/vagon-tipi-tanimlama", name: "carCreateView", component: carCreateView },
  {
    path: "/vagon-grubu-yonetimi",
    name: "carGroupListView",
    component: carGroupListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/nesne-vagon-sub-menu/vagon-grubu-yonetimi/show-page" },
  },
  {
    path: "/vagon-tasarimi-yonetimi",
    name: "seatMapListView",
    component: seatMapListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/nesne-vagon-sub-menu/vagon-tasarimi-yonetimi/show-page" },
  },
  { path: "/vagon-tasarimi-tanimlama", name: "seatMapCreateView", component: seatMapCreateView },
  // { path: "/parkur-bazli-fiyat-yonetimi", name: "parkourBasedPriceListView", component: parkourBasedPriceListView },
  {
    path: "/donanim-yonetimi",
    name: "hardwareListView",
    component: hardwareListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/istasyon-yonetimi-sub-menu/donanim-yonetimi/show-page" },
  },
  { path: "/404", name: "page404", component: page404 },
  { path: "/401", name: "page401", component: page401 },
  { path: "/500", name: "page500", component: page500 },
  { path: "/bakimdayiz", name: "pageMaintenance", component: pageMaintenance, meta: { hideHeaderAndFooter: true } },
  {
    path: "/istasyon-durum-yonetimi",
    name: "stationStatusListView",
    component: stationStatusListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/istasyon-yonetimi-sub-menu/istasyon-durum-yonetimi/show-page" },
  },
  {
    path: "/eslenik-istasyon-yonetimi",
    name: "equivalentStationListView",
    component: equivalentStationListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/istasyon-yonetimi-sub-menu/eslenik-istasyon-yonetimi/show-page" },
  },
  {
    path: "/trenim-nerede-istasyon-yonetimi",
    name: "trainWhereStationListView",
    component: trainWhereStationListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/istasyon-yonetimi-sub-menu/trenim-nerede-istasyon-yonetimi/show-page" },
  },
  {
    path: "/istasyon-tipi-yonetimi",
    name: "stationTypeListView",
    component: stationTypeListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/istasyon-yonetimi-sub-menu/istasyon-tipi-yonetimi/show-page" },
  },
  { path: "/birim-agaci", name: "unitTree", component: unitTree, meta: { permissionTag: "b2b/birim-personel-yonetimi-menu/birim-agaci/show-page" } },
  {
    path: "/ana-birim-yonetimi",
    name: "mainUnitListView",
    component: mainUnitListView,
    meta: { permissionTag: "b2b/birim-personel-yonetimi-menu/ana-birim-yonetimi/show-page" },
  },
  { path: "/ana-birim-tanimlama", name: "mainUnitCreateView", component: mainUnitCreateView },
  {
    path: "/satis-islemleri",
    name: "salesTransactionListView",
    component: salesTransactionsListView,
    meta: { permissionTag: "b2b/satis-islemleri-menu/satis-islemleri/show-page" },
  },
  { path: "/satis-ekrani-koltuk-secimi", name: "salesTransactionsSeatmap", component: salesTransactionsSeatmap },
  { path: "/satis-yonetimi-odeme", name: "salesTransactionPayment", component: salesTransactionPayment },
  { path: "/satis-yonetimi-bilet", name: "salesTransactionsTicketResult", component: salesTransactionsTicketResult },
  { path: "/satis-yonetimi-bilet-rezervasyon", name: "salesTransactionsTicketRezervation", component: salesTransactionsTicketRezervation },
  { path: "/bilet-sinif-kural-tanimlama", name: "ticketClassRulesCreateView", component: ticketClassRulesCreateView },
  {
    path: "/bilet-sinif-kural-yonetimi",
    name: "ticketClassRulesListView",
    component: ticketClassRulesListView,
    meta: { permissionTag: "b2b/fiyatlandirma-menu/envarter-yonetimi-sub-menu/bilet-sinif-kural-yonetimi/show-page" },
  },
  {
    path: "/sinif-yonetimi",
    name: "pageClassListView",
    component: pageClassListView,
    meta: { permissionTag: "b2b/fiyatlandirma-menu/envarter-yonetimi-sub-menu/sinif-yonetimi/show-page" },
  },
  { path: "/sinif-tanimlama", name: "pageClassCreateView", component: pageClassCreateView },
  {
    path: "/ucret-ailesi-yonetimi",
    name: "priceFamilyListView",
    component: priceFamilyListView,
    meta: { permissionTag: "b2b/fiyatlandirma-menu/envarter-yonetimi-sub-menu/ucret-ailesi-yonetimi/show-page" },
  },
  { path: "/tren-tanimlama", name: "trainCreateView", component: trainCreateView },
  {
    path: "/tren-yonetimi",
    name: "trainListView",
    component: trainListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/tren-yonetimi-sub-menu/tren-yonetimi/show-page" },
  },
  {
    path: "/tarife-yonetimi",
    name: "passengerTypeListView",
    component: passengerTypeListView,
    meta: { permissionTag: "b2b/fiyatlandirma-menu/fiyatlandirma-yonetimi-sub-menu/tarife-yonetimi/show-page" },
  },
  { path: "/tarife-tanimlama", name: "passengerTypeCreateView", component: passengerTypeCreateView },
  {
    path: "/kullanici-tanimlama",
    name: "userCreateView",
    component: userCreateView,
    meta: { permissionTag: "b2b/birim-personel-yonetimi-menu/kullanici-tanimlama/show-page" },
  },
  {
    path: "/kullanici-listeleme",
    name: "userListView",
    component: userListView,
    meta: { permissionTag: "b2b/birim-personel-yonetimi-menu/kullanici-listeleme/show-page" },
  },
  {
    path: "/kullanici-hesap-verilerini-listeleme",
    name: "userAccountDataListView",
    component: userAccountDataListView,
    meta: { permissionTag: "b2b/gise-yonetimi-menu/kullanici-hesap-verilerini-listeleme/show-page" },
  },
  {
    path: "/rol-yonetimi",
    name: "authorizationManagementView",
    component: authorizationManagementView,
    meta: { permissionTag: "b2b/birim-personel-yonetimi-menu/rol-yonetimi/show-page" },
  },
  { path: "/ozel-servis-hizmeti-tanimlama", name: "specialServiceCreateView", component: specialServiceCreateView },
  {
    path: "/ozel-servis-hizmeti-yonetimi",
    name: "specialServiceListView",
    component: specialServiceListView,
    meta: { permissionTag: "b2b/fiyatlandirma-menu/fiyatlandirma-yonetimi-sub-menu/ozel-servis-istegi-kategorisi/ozel-servis-hizmeti-yonetimi/show-page" },
  },
  {
    path: "/ozel-servis-istek-kategorisi",
    name: "specialServiceRequestCategoryListView",
    component: specialServiceRequestCategoryListView,
    meta: { permissionTag: "b2b/fiyatlandirma-menu/fiyatlandirma-yonetimi-sub-menu/ozel-servis-istegi-kategorisi/show-page" },
  },
  //{ path: "/ana-sayfa",name:"homeView",component: homeView},
  {
    path: "/ek-hizmet-yonetimi",
    name: "additionalServiceListView",
    component: additionalServiceListView,
    meta: { permissionTag: "b2b/fiyatlandirma-menu/fiyatlandirma-yonetimi-sub-menu/ek-hizmet-yonetimi/show-page" },
  },
  { path: "/ek-hizmet-tanimlama", name: "additionalServiceCreateView", component: additionalServiceCreateView },
  {
    path: "/ek-hizmet-turu-yonetimi",
    name: "additionalServiceTypeListView",
    component: additionalServiceTypeListView,
    meta: { permissionTag: "b2b/fiyatlandirma-menu/fiyatlandirma-yonetimi-sub-menu/ek-hizmet-turu-yonetimi/show-page" },
  },
  // { path: "/ek-hizmet-fiyat-yonetimi", name: "additionalServicePricingListView", component: additionalServicePricingListView },
  { path: "/komisyon-tablosu-tanimlama", name: "commissionTableCreateView", component: commissionTableCreateView },
  // { path: "/komisyon-tablosu-yonetimi", name: "commissionTableListView", component: commissionTableListView },
  {
    path: "/yetki-grup-yonetimi",
    name: "resourceGroupListView",
    component: resourceGroupListView,
    meta: { permissionTag: "b2b/birim-personel-yonetimi-menu/yetki-grup-yonetimi/show-page" },
  },
  { path: "/yetki-grup-tanimlama", name: "resourceGroupCreateView", component: resourceGroupCreateView },
  { path: "/tren-seti-tanimlama", name: "trainSetCreateView", component: trainSetCreateView },
  {
    path: "/tren-seti-yonetimi",
    name: "trainSetListView",
    component: trainSetListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/tren-yonetimi-sub-menu/tren-seti-yonetimi/show-page" },
  },
  { path: "/aktarmali-tren-tanimlama", name: "trainConnectingCreateView", component: trainConnectingCreateView },
  {
    path: "/aktarmali-tren-yonetimi",
    name: "trainConnectingListView",
    component: trainConnectingListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/tren-yonetimi-sub-menu/aktarmali-tren-yonetimi/show-page" },
  },
  { path: "/sefer-yonetimi", name: "seferView", component: sefer, meta: { permissionTag: "b2b/yonetici-islemleri-menu/sefer-yonetimi/show-page" } },
  { path: "/duyuru-tanimlama", name: "announcementCreateView", component: announcementCreateView },
  {
    path: "/duyuru-yonetimi",
    name: "announcementListView",
    component: announcementListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/duyuru-yonetimi/show-page" },
  },
  { path: "/hata-mesaji-ceviri-tanimlama", name: "messageTranslationCreateView", component: messageTranslationCreateView },
  {
    path: "/hata-mesaji-ceviri-yonetimi",
    name: "messageTranslationListView",
    component: messageTranslationListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/hata-mesaji-ceviri-yonetimi/show-page" },
  },
  { path: "/acente-yonetimi", name: "agentListView", component: agentListView, meta: { permissionTag: "b2b/acente-islemleri-menu/acente-yonetimi/show-page" } },
  { path: "/acente-tanimlama", name: "agentCreateView", component: agentCreateView },
  {
    path: "/acente-odeme-hesap-kapama-islemleri",
    name: "agentPaymentAccountClosingView",
    component: agentPaymentAccountClosingView,
    meta: { permissionTag: "b2b/acente-islemleri-menu/acente-odeme-hesap-kapama-islemleri/show-page" },
  },
  {
    path: "/acente-toplu-hesap-kapatma-islemleri",
    name: "agentMultipleCloseAccountPeriod",
    component: agentMultipleCloseAccountPeriod,
    meta: { permissionTag: "b2b/acente-islemleri-menu/acente-toplu-hesap-kapatma-islemleri/show-page" },
  },
  {
    path: "/acente-hesap-donemi-islemleri",
    name: "agentAccountingPeriodTransactions",
    component: agentAccountingPeriodTransactions,
    meta: { permissionTag: "b2b/acente-islemleri-menu/acente-hesap-donemi-islemleri/show-page" },
  },
  { path: "/acente-satis-raporlari", name: "agencySalesReportsView", component: agencySalesReportsView },
  { path: "/acente-donem-sonu-raporlama-islemleri", name: "agencyEndOfPeriodReportingProceduresView", component: agencyEndOfPeriodReportingProceduresView },
  {
    path: "/acente-hesap-donemi-islemleri-v2",
    name: "agentAccountingPeriodTransactionsV2",
    component: agentAccountingPeriodTransactionsV2,
    meta: { permissionTag: "b2b/acente-islemleri-menu/acente-hesap-donemi-islemleri/show-page" },
  },
  { path: "/acente-satis-raporlari-v2", name: "agencySalesReportsViewV2", component: agencySalesReportsViewV2 },
  { path: "/acente-donem-sonu-raporlama-islemleri-v2", name: "agencyEndOfPeriodReportingProceduresViewV2", component: agencyEndOfPeriodReportingProceduresViewV2 },
  { path: "/amir-onay-tablosu", name: "supervisorApprovalTableView", component: supervisorApprovalTableView },
  {
    path: "/personel-hesap-kapatma",
    name: "personnelAccountClosingView",
    component: personnelAccountClosingView,
    meta: { permissionTag: "b2b/gise-yonetimi-menu/hesap-durumu-goruntuleme-sub-menu/personel-hesap-kapatma/show-page" },
  },
  {
    path: "/hesap-kapatma-onay",
    name: "accountClosureConfirmationView",
    component: accountClosureConfirmationView,
    meta: { permissionTag: "b2b/gise-yonetimi-menu/hesap-durumu-goruntuleme-sub-menu/hesap-kapatma-onay/show-page" },
  },
  // { path: "/ek-gelir-tanimlama", name: "additionalRevenueCreateView", component: additionalRevenueCreateView },
  // { path: "/ek-gelir-girisi", name: "additionalRevenueEntranceListView", component: additionalRevenueEntranceListView },
  // { path: "/ek-gelir-girisi-tanimlama", name: "additionalRevenueEntranceCreateView", component: additionalRevenueEntranceCreateView },
  {
    path: "/ek-hizmet-kilometre-bazli-fiyatlandirma-tanimlama",
    name: "additionalServiceKilometricBasePricing",
    component: additionalServiceKilometricBasedPricingView,
    meta: { permissionTag: "b2b/fiyatlandirma-menu/fiyatlandirma-yonetimi-sub-menu/ek-hizmet-kilometre-bazli-fiyatlandirma-tanimlama/show-page" },
  },
  {
    path: "/ssr-kilometre-bazli-fiyatlandirma-tanimlama",
    name: "ssrKilometricBasePricing",
    component: ssrKilometricBasedPricingView,
    meta: { permissionTag: "b2b/fiyatlandirma-menu/fiyatlandirma-yonetimi-sub-menu/ssr-kilometre-bazli-fiyatlandirma-tanimlama/show-page" },
  },
  {
    path: "/ek-hizmet-parkur-bazli-fiyatlandirma-tanimlama",
    name: "additionalServiceParkourBasePricing",
    component: additionalServiceParkourBasedPricingView,
    meta: { permissionTag: "b2b/fiyatlandirma-menu/fiyatlandirma-yonetimi-sub-menu/ek-hizmet-parkur-bazli-fiyatlandirma-tanimlama/show-page" },
  },
  {
    path: "/ssr-parkur-bazli-fiyatlandirma-tanimlama",
    name: "ssrParkourBasePricing",
    component: ssrParkourBasedPricingView,
    meta: { permissionTag: "b2b/fiyatlandirma-menu/fiyatlandirma-yonetimi-sub-menu/ssr-parkur-bazli-fiyatlandirma-tanimlama/show-page" },
  },
  {
    path: "/kky-hesap-aktarimi",
    name: "KKYAccountTransferView",
    component: KKYAccountTransferView,
    meta: { permissionTag: "b2b/gise-yonetimi-menu/kky-hesap-aktarimi/show-page" },
  },
  {
    path: "/gise-yonetimi",
    name: "boxOfficeListView",
    component: boxOfficeListView,
    meta: { permissionTag: "b2b/gise-yonetimi-menu/gise-yonetimi/show-page" },
  },
  { path: "/gise-tanimlama", name: "boxOfficeCreateView", component: boxOfficeCreateView },
  {
    path: "/musteri-tanimlama",
    name: "customerCreateView",
    component: customerCreateView,
    meta: { permissionTag: "b2b/yolcu-islemleri-menu/musteri-tanimlama/show-page" },
  },
  {
    path: "/musteri-yonetimi",
    name: "customerListView",
    component: customerListView,
    meta: { permissionTag: "b2b/yolcu-islemleri-menu/musteri-yonetimi/show-page" },
  },
  { path: "/musteri-satin-alma-gecmisi", name: "customerPurchaseHistoryView", component: customerPurchaseHistoryView },
  { path: "/musteri-baglanti-cihazlari", name: "customerConnectedDevicesView", component: customerConnectedDevicesView },
  {
    path: "/kilometre-bazli-fiyatlandirma-tanimlama",
    name: "kilometricBasePricing",
    component: kilometricBasedPricingView,
    meta: { permissionTag: "b2b/fiyatlandirma-menu/fiyatlandirma-yonetimi-sub-menu/ek-hizmet-kilometre-bazli-fiyatlandirma-tanimlama/show-page" },
  },
  {
    path: "/parkur-bazli-fiyatlandirma-tanimlama",
    name: "parkourBasePricing",
    component: parkourBasedPricingView,
    meta: { permissionTag: "b2b/fiyatlandirma-menu/fiyatlandirma-yonetimi-sub-menu/ek-hizmet-parkur-bazli-fiyatlandirma-tanimlama/show-page" },
  },
  { path: "/parkur-bazli-dinamik-fiyatlandirma-tanimlama", name: "parkourBasedDynamicPricingView", component: parkourBasedDynamicPricingView },
  { path: "/kilometre-bazli-dinamik-fiyatlandirma-tanimlama", name: "kilometricBasedDynamicPricingView", component: kilometricBasedDynamicPricingView },
  { path: "/kontenjan-tanimlama", name: "kontenjanCreateView", component: kontenjanCreateView },
  {
    path: "/kontenjan-yonetimi",
    name: "kontenjanListView",
    component: kontenjanListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/kontenjan-yonetimi/kontenjan-yonetimi/show-page" },
  },
  {
    path: "/vagon-aktarma-sablonu",
    name: "seatMapConnectingTemplateListView",
    component: seatMapConnectingTemplateListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/nesne-vagon-sub-menu/vagon-aktarma-sablonu/show-page" },
  },
  { path: "/vagon-aktarma-tanimlama", name: "seatMapConnectingTemplateCreateView", component: seatMapConnectingTemplateCreateView },
  {
    path: "/tren-kontenjan-islemleri",
    name: "trainKontenjanAssignmentView",
    component: trainKontenjanAssignmentView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/kontenjan-yonetimi/tren-kontenjan-islemleri/show-page" },
  },
  {
    path: "/sefer-kontenjan-islemleri",
    name: "SeferKontenjanAssignmentView",
    component: SeferKontenjanAssignmentView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/kontenjan-yonetimi/sefer-kontenjan-islemleri/show-page" },
  },
  { path: "/satis-kanali-islemleri", name: "SaleChannelListView", component: SaleChannelListView },
  {
    path: "/abonmanlik-paket-yonetimi",
    name: "subscriptionPackageListView",
    component: subscriptionPackageListView,
    meta: { permissionTag: "b2b/paket-islemleri-menu/abonmanlik-yonetimi-sub-menu/abonmanlik-paket-yonetimi/show-page" },
  },
  { path: "/abonmanlik-paket-tanimlama", name: "subscriptionPackageCreateView", component: subscriptionPackageCreateView },
  {
    path: "/paket-satis",
    name: "packageSaleView",
    component: packageSaleView,
    meta: { permissionTag: "b2b/paket-islemleri-menu/abonmanlik-yonetimi-sub-menu/paket-satis/show-page" },
  },
  {
    path: "/indirim-paket-yonetimi",
    name: "discountPackageListView",
    component: discountPackageListView,
    meta: { permissionTag: "b2b/paket-islemleri-menu/indirim-paket-yonetimi/show-page" },
  },
  { path: "/indirim-paket-tanimlama", name: "discountPackageCreateView", component: discountPackageCreateView },
  { path: "/parametre-tanimlama", name: "parameterCreateView", component: parameterCreateView },
  {
    path: "/parametre-yonetimi",
    name: "parameterListView",
    component: parameterListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/parametre-yonetimi/show-page" },
  },
  {
    path: "/unvan-yonetimi",
    name: "titleListView",
    component: titleListView,
    meta: { permissionTag: "b2b/birim-personel-yonetimi-menu/unvan-yonetimi/show-page" },
  },
  {
    path: "/bilet-islemleri",
    name: "ticketTransactions",
    component: ticketTransactions,
    meta: { permissionTag: "b2b/yolcu-islemleri-menu/bilet-islemleri/show-page" },
  },
  { path: "/rapor-sayfasi/:slug", name: "/rapor-sayfasi", component: firstReport },
  { path: "/aylik-satis-reddiyat-raporu", name: "monthlySalesRejectionReport", component: monthlySalesRejectionReport },
  { path: "/test-bilet-islemleri", name: "HtmlTicketTransactions", component: HtmlTicketTransactions },
  { path: "/bildirim-planlama", name: "notificationListView", component: notificationListView },
  { path: "/bildirim-tanimlama", name: "notificationCreateView", component: notificationCreateView },
  { path: "/bilgilendirme-yonetimi", name: "informationListView", component: informationListView },
  { path: "/bilgilendirme-tanimlama", name: "informationCreateView", component: informationCreateView },
  {
    path: "/doluluk-bilgilendirme-listesi",
    name: "occupancyNotificationListView",
    component: occupancyNotificationListView,
    // meta: { permissionTag: "b2b/yonetici-islemleri-menu/bildirim-yonetimi/doluluk-bilgilendirmesi/show-page" },
  },
  { path: "/uye-kara-liste-yonetimi", name: "memberBlacklistView", component: memberBlacklistView },
  { path: "/kara-liste-kural-yonetimi", name: "blackListRuleView", component: blackListRuleView },
  { path: "/kara-liste-kural-tanimlama", name: "blackListRuleCreateView", component: blackListRuleCreateView },
  { path: "/askeri-birlik-yonetimi", name: "militaryUnitsListView", component: militaryUnitsListView },
  { path: "/muhtira-islemleri", name: "muhtiraTransactionsView", component: muhtiraTransactionsView },
  { path: "/muhtira-goruntuleme-indirme", name: "muhtiraDownloadListView", component: muhtiraDownloadListView },
  { path: "/kurum-kaynakli-iade", name: "corporateBasedTransactionsView", component: corporateBasedTransactionsView },
  {
    path: "/tren-bolge-yonetimi",
    name: "trainRegionList",
    component: trainRegionList,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/tren-yonetimi-sub-menu/tren-bolge-yonetimi/show-page" },
  },
  { path: "/tren-seti-aktarma-sablonu", name: "trainSetMappingListView", component: trainSetMappingListView },
  { path: "/tren-seti-aktarma-sablonu-tanimlama", name: "trainSetMappingCreateView", component: trainSetMappingCreateView },
  // { path: "/uygulama-versiyon", name: "appVersion", component: appVersionListView },
  {
    path: "/aktarmali-tren-indirimi-yonetimi",
    name: "connectedTrainDiscountListView",
    component: connectedTrainDiscountListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/tren-yonetimi-sub-menu/aktarmali-tren-indirimi-yonetimi/show-page" },
  },
  { path: "/aktarmali-tren-indirimi-tanimlama", name: "connectedTrainDiscountCreateView", component: connectedTrainDiscountCreateView },
  { path: "/toplu-biletleme", name: "bulkTicketing", component: bulkTicketing },
  { path: "/interrail-eurail", name: "internationalTicketTransactions", component: internationalTicketTransactions },
  { path: "/interrail-eurail-sepet", name: "internationalTicketCardDetails", component: internationalTicketCardDetails },
  { path: "/interrail-eurail-yolcu-bilgileri", name: "internationalTicketPassengerInformation", component: internationalTicketPassengerInformation },
  { path: "/interrail-eurail-odeme", name: "internationalTicketPayment", component: internationalTicketPayment },
  { path: "/interrail-eurail-odeme-sonuc", name: "internationalTicketResult", component: internationalTicketResult },
  { path: "/interrail-eurail-iade", name: "InternationalTicketRefund", component: InternationalTicketRefund },
  { path: "/kullanici-degerlendirmeleri", name: "evaluationsListView", component: evaluationsListView },
  {
    path: "/tren-yolcularina-sms-gonder",
    name: "sendTrainPassengersSms",
    component: sendTrainPassengersSms,
    meta: { permissionTag: "mc/send-sms/trainandsubscription-passengers/show-page" },
  },
  {
    path: "/giden-dekont-uretme",
    name: "outgoingReceiptsCreateView",
    component: outgoingReceiptsCreateView,
    meta: { permissionTag: "b2b/uluslararasi-mahsuplasma-menu/giden-dekont-uretme/show-page" },
  },
  {
    path: "/yardim-sayfasi-yonetimi",
    name: "helpMainHeaderListView",
    component: helpMainHeaderListView,
    meta: { permissionTag: "b2b/yonetici-islemleri-menu/yardim-sayfasi-yonetimi/show-page" },
  },
  { path: "/yardim-sayfasi-tanimlama", name: "helpMainHeaderCreateView", component: helpMainHeaderCreateView },
  { path: "/islem-gecmisi", name: "historyView", component: historyView },
  {
    path: "/kayip-esya-personel-islemleri",
    name: "lostPropertyStaffOperationsView",
    component: lostPropertyStaffOperationsView,
    meta: { permissionTag: "b2b/kayip-esya-menu/personel-islemleri/show-page" },
  },
  {
    path: "/kayip-esya-yonetici-islemleri",
    name: "lostPropertyAdminOperationsView",
    component: lostPropertyAdminOperationsView,
    meta: { permissionTag: "b2b/kayip-esya-menu/yonetici-islemleri/show-page" },
  },
  {
    path: "/kayip-esya-ayarlar",
    name: "lostPropertySettingsView",
    component: lostPropertySettingsView,
    meta: { permissionTag: "b2b/kayip-esya-menu/ayarlar/show-page" },
  },
];
